import { useAuth as useClerkAuth } from '@clerk/clerk-react';

export const IS_DEV_AUTH =
  process.env.NODE_ENV !== 'production' && !!process.env.REACT_APP_DEV_USER;

type AuthState = { isSignedIn: boolean };

function useClerkAuthWrapper(): AuthState {
  const { isSignedIn } = useClerkAuth();
  return { isSignedIn: !!isSignedIn };
}

function useDevAuthStub(): AuthState {
  return { isSignedIn: true };
}

export const useDevAuth = IS_DEV_AUTH ? useDevAuthStub : useClerkAuthWrapper;
